"use client"

import React, { createContext, PropsWithChildren } from 'react'

type SignupUserIdContext = {
    userId: number,
    setUserId: (userId: number) => void,
}

export const SignupUserIdContext = createContext<SignupUserIdContext | null>(null)

export const SignupUserIdContextProvider = ({ children }: PropsWithChildren) => {
    const [userId, setUserId] = React.useState<number>(0)
    return (
        <SignupUserIdContext.Provider value={{ userId, setUserId }}>
            {children}
        </SignupUserIdContext.Provider>
    )
}

export const useSignupUserIdContext = () => {
    const context = React.useContext(SignupUserIdContext)
    if (!context) {
        throw new Error('useSignupUserIdContext must be used within a SignupUserIdContextProvider')
    }
    return context
}
